import { SetItemPriceType } from "../../types";
import { SetItemPriceFormType } from "../validations";

export function isItemChanged(value: SetItemPriceFormType, originalData: SetItemPriceType[]) {
   return value?.setItem?.filter((item) => {
        const original = originalData?.find(o => o.product_id.toString() === item.product_id.toString())
        if (!original) return true;
        return (
            Number(original.price_retail) !== Number(item.price_retail) ||
            Number(original.wholesales_price) !== Number(item.wholesales_price) ||
            Number(original.distributor_price) !== Number(item.distributor_price) ||
            Number(original.factory_price) !== Number(item.factory_price) ||
            Number(original.online_price) !== Number(item.online_price) ||
            Number(original.special_arrangement_price) !== Number(item.special_arrangement_price)
        )
    })
}
